import { ColDef } from 'ag-grid-community';
import { BooleanFilterComponent } from '@mydocma/component-library/src/lib/grid';
import { ListFilterComponent } from '@mydocma/component-library/src/lib/grid';

export const NumberColDef: ColDef = {
  filter: 'agNumberColumnFilter',
  sortable: true,
  filterValueGetter: (params) => null,
 // rowDrag: true,
  filterParams: {
    suppressAndOrCondition: true,
    includeBlanksInLessThan: true,
    includeBlanksInGreaterThan: true,
    includeBlanksInEquals: true,
    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual']
  },
};

export const PositiveIntegerColDef: ColDef = {
  filter: 'agNumberColumnFilter',
  sortable: true,
  filterValueGetter: (params) => null,
 // rowDrag: true,
  filterParams: {
    allowedCharPattern: '\\d',
    suppressAndOrCondition: true,
    includeBlanksInLessThan: true,
    includeBlanksInGreaterThan: true,
    includeBlanksInEquals: true,
    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual']
  }
};

export const TextColDef: ColDef = {
  filter: 'agTextColumnFilter',
  sortable: true,
  filterParams: {
    suppressAndOrCondition: true,
    textCustomComparator: (filter, value, filterText) =>  true,
    filterOptions: ['contains']
  }
};

export const DateColDef: ColDef = {
  // width: 104,
  filter: 'agDateColumnFilter',
  sortable: true,
  type: 'Date',
  filterValueGetter: (params) => null,
  filterParams: {
    suppressAndOrCondition: true,
    includeBlanksInLessThan: true,
    includeBlanksInGreaterThan: true,
    includeBlanksInEquals: true,
    comparator: ()=> true,
    filterOptions: ['equals', 'notEqual', 'lessThan', 'greaterThan', 'empty']
  }
};

export const ImageColDef: ColDef = {
  cellRenderer: 'attachmentRenderer',
  filter: false,
  tooltipComponent: 'attachmentTooltip',
  cellClass: "image-cell",
  type: 'Image'
};

export const DelayColDef: ColDef = {
  cellRenderer: 'delayRenderer',
  filter: false,
  sortable: true,
};

export const AttributeGroupColDef: ColDef = {
  cellRenderer: 'attributeGroupRenderer',
  filter: false,
  cellClass: 'attribute-group-cell'
};

export const BooleanColDef: ColDef = {
  cellRenderer: 'checkboxRenderer',
  sortable: true,
  type: 'Boolean',
  filterValueGetter: (params) => null,
  filter: ListFilterComponent,
  filterParams: {
    comparator: () => true,
    showAllOption: false,
    selectableOptions: [
      {
        id: 100,
        value: true,
        selected: true,
        text: 'MM.gridBoolean.selected'
      },
      {
        id: 200,
        value: false,
        selected: true,
        text: 'MM.gridBoolean.not-selected'
      },
    ]
  }
};

export const SalutationColDef: ColDef = {
  cellRenderer: 'salutationRenderer',
  type: 'Salutation',
  sortable: true,
};

export const StatusGroupColDef: ColDef = {
  type: 'StatusGroup',
  sortable: true,
  filterValueGetter: (params) => null,
  filter: ListFilterComponent,
  filterParams: {
    comparator: () => true,
    showAllOption: false,
    selectableOptions: [
      {
        id: 100,
        value: 1,
        selected: true,
        text: 'MM.statusGroup.1'
      },
      {
        id: 200,
        value: 2,
        selected: true,
        text: 'MM.statusGroup.2'
      },
    ]
  }
};

export const TimeColDef: ColDef = {
  type: 'time',
  sortable: true,
  valueFormatter: (x) => {
    return !x.value ? '' : x.value.split('.')[0]
  }
}
